import React from 'react';
import Card from '../../ui/Card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';
import { SmartphoneIcon, MonitorIcon, TabletIcon } from 'lucide-react';
const DeviceBreakdownChart: React.FC = () => {
  const data = [{
    device: 'Mobile',
    visits: 107544,
    percentage: 58,
    bounceRate: 45.2,
    avgSession: 3.2,
    color: '#3b82f6',
    icon: <SmartphoneIcon size={20} data-id="element-7380" />
  }, {
    device: 'Desktop',
    visits: 63143,
    percentage: 34,
    bounceRate: 38.5,
    avgSession: 4.8,
    color: '#10b981',
    icon: <MonitorIcon size={20} data-id="element-7381" />
  }, {
    device: 'Tablet',
    visits: 14834,
    percentage: 8,
    bounceRate: 41.8,
    avgSession: 3.9,
    color: '#f59e0b',
    icon: <TabletIcon size={20} data-id="element-7382" />
  }];
  return <Card className="p-6" data-id="element-7383">
      <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-7384">
        Device Breakdown
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-7385">
        Traffic distribution by device type
      </p>
      <ResponsiveContainer width="100%" height={300} data-id="element-7386">
        <BarChart data={data} data-id="element-7387">
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-7388" />
          <XAxis dataKey="device" tick={{
          fontSize: 12
        }} data-id="element-7389" />
          <YAxis tick={{
          fontSize: 12
        }} data-id="element-7390" />
          <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }} formatter={(value: number) => value.toLocaleString()} data-id="element-7391" />
          <Legend data-id="element-7392" />
          <Bar dataKey="visits" name="Visits" radius={[8, 8, 0, 0]} data-id="element-7393">
            {data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-7394" />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-7395">
        <div className="space-y-3" data-id="element-7396">
          {data.map((device, index) => <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-7397">
              <div className="flex items-center space-x-3" data-id="element-7398">
                <div className="p-2 rounded-lg" style={{
              backgroundColor: `${device.color}20`
            }} data-id="element-7399">
                  <div style={{
                color: device.color
              }} data-id="element-7400">
                    {device.icon}
                  </div>
                </div>
                <div data-id="element-7401">
                  <div className="text-sm font-semibold text-gray-900" data-id="element-7402">
                    {device.device}
                  </div>
                  <div className="text-xs text-gray-600" data-id="element-7403">
                    {device.visits.toLocaleString()} visits ({device.percentage}
                    %)
                  </div>
                </div>
              </div>
              <div className="text-right" data-id="element-7404">
                <div className="text-sm text-gray-700" data-id="element-7405">
                  Bounce: {device.bounceRate}%
                </div>
                <div className="text-xs text-gray-600" data-id="element-7406">
                  Avg: {device.avgSession} min
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </Card>;
};
export default DeviceBreakdownChart;